var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBIcon = function SvgBIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F5F5F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1249 24.884C15.1249 25.514 15.6109 26 16.2409 26H20.9569C23.7649 26 25.6189 24.794 25.6189 22.544V22.508C25.6189 20.798 24.5929 19.952 23.1169 19.448C24.0529 18.962 24.9169 18.152 24.9169 16.64V16.604C24.9169 15.758 24.6289 15.074 24.0709 14.516C23.3509 13.796 22.2169 13.4 20.7769 13.4H16.2409C15.6109 13.4 15.1249 13.886 15.1249 14.516V24.884ZM17.3029 18.71V15.362H20.4889C21.9109 15.362 22.7029 15.974 22.7029 16.964V17C22.7029 18.152 21.7489 18.71 20.3269 18.71H17.3029ZM17.3029 24.038V20.582H20.8129C22.5589 20.582 23.4049 21.212 23.4049 22.274V22.31C23.4049 23.444 22.4869 24.038 20.9749 24.038H17.3029Z",
    fill: "#171A20"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/b-icon.3f6348452de3eac076c24c7a6da192ed.svg";